import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { LibraryRoutingModule } from './library-routing.module';
import { LibraryConfiguationComponent } from './library-configuation/library-configuation.component';
import { LibraryTypeComponent } from './library-type/library-type.component';
import { BookTypeComponent } from './book-type/book-type.component';
import { BookTitleComponent } from './book-title/book-title.component';
import { BookEditionComponent } from './book-edition/book-edition.component';
import { PublicationComponent } from './publication/publication.component';
import { BookGruopComponent } from './book-gruop/book-gruop.component';
import { AuthorComponent } from './author/author.component';
import { GenerateLibraryCardNoComponent } from './generate-library-card-no/generate-library-card-no.component';
import { BookStatusComponent } from './book-status/book-status.component';
import { BookComponent } from './book/book.component';
import { CDComponent } from './cd/cd.component';
import { JournalsComponent } from './journals/journals.component';
import { BookISBNComponent } from './book-isbn/book-isbn.component';
import { BookIssuesComponent } from './book-issues/book-issues.component';
import { BookslostReportComponent } from './bookslost-report/bookslost-report.component';
import { BooksIssueReportComponent } from './books-issue-report/books-issue-report.component';
import { BookStockReportComponent } from './book-stock-report/book-stock-report.component';
import { BookFineCollectionComponent } from './book-fine-collection/book-fine-collection.component';
import { AdminModule } from '../admin/admin.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BsDatepickerModule, TypeaheadModule } from 'ngx-bootstrap';


@NgModule({
  declarations: [LibraryConfiguationComponent, LibraryTypeComponent, BookTypeComponent, BookTitleComponent, BookEditionComponent, PublicationComponent, BookGruopComponent, AuthorComponent, GenerateLibraryCardNoComponent, BookStatusComponent, BookComponent, CDComponent, JournalsComponent, BookISBNComponent, BookIssuesComponent, BookslostReportComponent, BooksIssueReportComponent, BookStockReportComponent, BookFineCollectionComponent],
  imports: [
    CommonModule,
    LibraryRoutingModule,
    AdminModule,
    FormsModule,
    ReactiveFormsModule,
    BsDatepickerModule.forRoot(),
    
    TypeaheadModule.forRoot(),

  ]
})
export class LibraryModule { }
